export const configureChartDefaults = (defaults) => {
    if (!defaults?.font || !defaults?.layout?.padding) return;

    defaults.font.family = "'Sage Text', sans-serif";
    defaults.layout.padding.left = -8;
    defaults.layout.padding.right = -8;
};
